import {
  getWithOptionalAuthorizationGeneric,
} from "./api";
import { NOTIFICATION_BASE, GEOFENCE_NOTIFICATION_BASE } from "./apiConstant";
import { getToken } from "./auth";
import { decryptMessage } from "../utils/decrypt";

export interface NotificationMobileSummary {
  status: number;      // 0 = Draft, 1 = Active, 2 = Upcoming, 3 = Past
  totalCount: number;
  createdAt: string;
}

export interface CardCount {
  key: string;
  total: number;
  lastDate?: string;
}

const mapStatusToKey = (status: number) =>
  status === 0 ? "drafts" :
    status === 1 ? "active" :
      status === 2 ? "upcoming" : "past";

const notificationMobileApi = {
  getNotificationsMobileList: async (): Promise<CardCount[]> => {
    try {
      const url = `${NOTIFICATION_BASE}/status-summary`;
      const encryptedResponse = await getWithOptionalAuthorizationGeneric<any[]>(url, true);

      const token = getToken();
      if (!token) throw new Error("No token found");

      const decryptedData: NotificationMobileSummary[] = await decryptMessage(encryptedResponse.data.Data, token);

      if (!Array.isArray(decryptedData)) throw new Error("Invalid response format");

      return decryptedData.map(item => ({
        key: mapStatusToKey(item.status),
        total: item.totalCount ?? 0,
        lastDate: item.createdAt ?? "",
      }));
    } catch (error) {
      console.error(" Error fetching mobile notifications:", error);
      throw error;
    }
  },

  getNotificationsGeofenceList: async (): Promise<CardCount[]> => {
    try {
      const url = `${GEOFENCE_NOTIFICATION_BASE}/status-summary`;
      const encryptedResponse = await getWithOptionalAuthorizationGeneric<any[]>(url, true);

      const token = getToken();
      if (!token) throw new Error("No token found");

      const decryptedData: NotificationMobileSummary[] = await decryptMessage(encryptedResponse.data.Data, token);

      if (!Array.isArray(decryptedData)) throw new Error("Invalid response format");

      return decryptedData.map(item => ({
        key: mapStatusToKey(item.status),
        total: item.totalCount ?? 0,
        lastDate: item.createdAt ?? "",
      }));
    } catch (error) {
      console.error(" Error fetching geofence notifications:", error);
      throw error;
    }
  },
};

//  Fetch Mobile notification counts
export const fetchMobileCardCounts = async (): Promise<CardCount[]> => {
  return await notificationMobileApi.getNotificationsMobileList();
};

// Fetch Geofence notification counts
export const fetchGeofenceCardCounts = async (): Promise<CardCount[]> => {
  return await notificationMobileApi.getNotificationsGeofenceList();
};

export default notificationMobileApi;
